import * as React from 'react';

import emptyImage from '../images/empty.png';

export function InterventionsEmptyState() {
	return (
		<div className='pt-6 w-full max-w-7xl mx-auto text-center'>
			<img alt='' className='inline-block' height='225' src={emptyImage} width='307' />
			<h2 className='pb-14 mt-3 font-display text-md font-semibold text-gray-400'>Scenario list empty</h2>
		</div>
	);
}
